import React, { useEffect, useRef, useState } from "react"
import { getStorefrontPopupApplicableStyles } from "./storefrontPopupConstants"
import { replaceWithRegexMap } from "./utils"

export const StorefrontPopupQuickEdit = ({ id, editMode, quickEdit }) => {
    if (!editMode) return null
    return <>
        <div
            class="edit edit-button"
            onClick={() => {
                quickEdit && quickEdit(id)
            }}
        >
            <i class="icon icon--xs icon-Pencil"></i>
        </div>
    </>
}

export const StorefrontPopupCoupon = (props) => {
    const { id, label, currentDevice, align, clickToCopy, copiedText, deviceType, editMode, handleComponentQuickEdit} = props
    const [couponText, setCouponText] = useState(label)
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const handleCopyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(label)
            setCouponText(copiedText)
            setTimeout(() => {
                setCouponText("")
            }, 3000)
        } catch (err) {}
    }
    return (
        <>
            {deviceType[currentDevice] && <div className={editMode ? "storefront-popup-custom-edit-block" : ""} align={align}>
                <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                <div
                    style={getStyleSheet()}
                    onMouseEnter={() => {
                        setCouponText(clickToCopy);
                    }}
                    onMouseLeave={() => {
                        if (copiedText == couponText) {
                                setTimeout(() => {
                                setCouponText("")
                            }, 3000)
                        } else {
                            setCouponText("")
                        }
                    }}
                    onClick={() => {
                        handleCopyToClipboard()
                    }}
                >
                    <span>{couponText || label}</span>
                </div>
            </div>}
        </>
    )
}

export const StorefrontPopupText = (props) => {
    const { id, label, currentDevice, align, editMode, deviceType, tokenReplacementObject, handleComponentQuickEdit } = props
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const getLabelValue = () => {
        if (!editMode && tokenReplacementObject) {
            return replaceWithRegexMap(label, tokenReplacementObject)
        }
        return label
    } 
    return (
        <>
            {deviceType[currentDevice] && <div className={editMode ? "storefront-popup-custom-edit-block" : ""} style={getStyleSheet()} align={align}>
                <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                {getLabelValue()}
            </div>}
        </>
    )
}

export const StorefrontPopupImage = (props) => {
    const { id, src = "", label, currentDevice, editMode, deviceType, handleComponentQuickEdit, popupPosition } = props
    const [editHeight, setEditHeight] = useState(20)
    const [imageLoaded, setImageLoaded] = useState(false)
    const ref = useRef(null)
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    useEffect(() => {
        if (editMode && imageLoaded && ref?.current) {
            setEditHeight(ref?.current?.clientHeight || 20)
        }
    }, [popupPosition])
    if (!deviceType[currentDevice]) return null
    return (
        <>  
            { editMode && <div style={{ height: 0, position: "relative" }}>
                <div className="storefront-popup-custom-edit-block" style={{ height: `${editHeight}px`, position: "absolute", backgroundColor: "#ffffff00", width: "100%", top: 0, zIndex: "1010"  }}>
                    <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                </div>
            </div>}
            <img ref={ref} className="storefront-popup-custom-edit-block-img" style={getStyleSheet()} src={src} alt={label || ""} onLoad={() => {
                setImageLoaded(true)
                if (!ref?.current || !editMode) return;
                setEditHeight(ref?.current?.clientHeight || 20)
            }} />
        </>
    )
}

export const StorefrontPopupSpacing = (props) => {
    const { id, currentDevice, editable, editMode, deviceType, handleComponentQuickEdit } = props
    const getStyleSheet = () => {
        let styles = getStorefrontPopupApplicableStyles(currentDevice, props)
        styles.border = `${editable ? 1 : 0}px dotted #ccc`
        return styles
    }
    return (
        <>
            {deviceType[currentDevice] && <div
                    style={getStyleSheet()}
                    className={editMode ? "storefront-popup-custom-edit-block" : ""}
                >
                    <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                </div>
            }
        </>
    )
}

export const StorefrontPopupInput = (props) => {
    const { id, label = "Email", name = "emailAddress", type = "text", currentDevice, editMode, deviceType, formData, setFormData, formDataError, handleComponentQuickEdit } = props
    const [value, setValue] = useState("")
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const onChangeHandler = (e) => {
        setValue(e.target.value)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: e.target.name,
                    value: e.target.value
                }
            })
        }
    }
    return (
        <>
            {deviceType[currentDevice] && <div className={editMode ? "storefront-popup-custom-edit-block" : ""}>
                <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                <input
                    style={getStyleSheet()}
                    name={name}
                    value={value}
                    onChange={onChangeHandler}
                    placeholder={label}
                    type={type}
                />
                {deviceType[currentDevice] && formDataError[id] && <div className="storefront-popup-error">
                    {formDataError[id]}
                </div>}
            </div>}
        </>
    )
}

export const StorefrontPopupButton = (props) => {
    const { id, formDataError, label = "Submit", action = "none", currentDevice, align, deviceType, editMode, handleClosePopup, handleSubmitLead, handleProductSubscibe, handleAddToCartMoreDetails, handleComponentQuickEdit } = props
    const clickCallMap = {
        "none": null,
        "closepopup": handleClosePopup,
        "submitlead": () => {
            handleSubmitLead && handleSubmitLead(id)
        },
        "subscribe": () => {
            handleProductSubscibe && handleProductSubscibe()
        },
        "addtocartmoredetails": () => {
            handleAddToCartMoreDetails && handleAddToCartMoreDetails(id)
        }
    }

    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }

    return (
        <>
            {deviceType[currentDevice] && <div align={align}>
                <button
                    className={`btn ${editMode ? "storefront-popup-custom-edit-block" : ""}`}
                    onClick={false && editMode ? null : clickCallMap[action]}
                    style={getStyleSheet()}
                >
                    <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                    {label}
                </button>
                {formDataError && formDataError[id] && <div className="storefront-popup-error">{formDataError[id]}</div>}
            </div>}
        </>
    )
}

export const StorefrontPopupLink = (props) => {
    const { id, align = "center", label = "Submit", currentDevice, href = "", target = "", editMode, deviceType, handleComponentQuickEdit} = props
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    return (
        <>
            {deviceType[currentDevice] && <div
                align={align}
                className={editMode ? "storefront-popup-custom-edit-block" : ""}
            >
                <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                <a href={href ? href : ""} target={target} style={getStyleSheet()}>{label}</a>
            </div>}
        </>
    )
}

export const StorefrontPopupCloseButton = (props) => {
    const { popupData, display = "block", handleClosePopup } = props
    const getStyleSheet = () => {
        const obj = {
            display,
            color: popupData.closeButtonColor,
            backgroundColor: popupData.closeButtonBackgroundColor
        };
        if (["topBar", "bottomBar", "left", "right"].includes(popupData.position)) {
            obj.top = "5px"
            obj.right = "5px"
        }
        return obj
    }
    return (
        <>
            <div
                className='storefront-popup-close-btn'
                style={getStyleSheet()}
                onClick={() => {
                    handleClosePopup && handleClosePopup()
                }}
            >
                <span>&times;</span>
            </div>
        </>
    )
}

export const StorefrontPopupFrequencySelect = (props) => {
    const { id, name = "frequency", currentDevice, editMode, deviceType, formData, setFormData, formDataError, subProduct, product, handleComponentQuickEdit } = props
    const [selectValue, setSelectValue] = useState("")
    const [frequency, setFrequency] = useState([])
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const onChangeHandler = (e) => {
        setSelectValue(e.target.value)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: e.target.name,
                    value: e.target.value
                }
            })
        }
    }
    useEffect(() => {
        if (!product || !subProduct) return;
        let frequencyOptions = [];
        if (product.subscriptionOptions) {
            frequencyOptions = product.subscriptionOptions.split(",").map(opt => {
                const value = opt.trim();
                return { value, label: value };
            });
        } else if (subProduct?.cycle1_billDelay) {
            const days = `${subProduct.cycle1_billDelay} Days`;
            frequencyOptions = [{ value: days, label: days }];
        }
        setSelectValue(frequencyOptions?.[0]?.value)
        setFrequency(frequencyOptions)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: name,
                    value: frequencyOptions?.[0]?.value
                }
            })
        }
    }, [subProduct, product]);
    return (
        <>
            {deviceType[currentDevice] && <div
                className={editMode ? "storefront-popup-custom-edit-block" : ""}
            >
                <StorefrontPopupQuickEdit id={id} quickEdit={handleComponentQuickEdit} editMode={editMode} />
                <select
                    name={name}
                    style={getStyleSheet()}
                    onChange={onChangeHandler}
                >
                    {
                        frequency.length ?
                            frequency.map(({ label, value }) => {
                                return <option selected={value === selectValue} value={value}>{label}</option>
                            })
                        : <option value="">Select</option>
                    }
                </select>
                {deviceType[currentDevice] && formDataError && formDataError[id] && <div className="storefront-popup-error">
                    {formDataError[id]}
                </div>}
            </div>}
        </>
    )
}

export const storefrontPopupComponentMap = {
    "text": StorefrontPopupText,
    "image": StorefrontPopupImage,
    "button": StorefrontPopupButton,
    "spacing": StorefrontPopupSpacing,
    "link": StorefrontPopupLink,
    "coupon": StorefrontPopupCoupon,
    "input": StorefrontPopupInput,
    "frequency": StorefrontPopupFrequencySelect
}